import { UserManagement } from "@/components/admin/UserManagement";

export default function UsersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">User Management</h2>
        <p className="text-muted-foreground">Manage users and their roles</p>
      </div>
      <UserManagement />
    </div>
  );
}
